<script lang="ts" setup>
import { computed } from 'vue'
import type { LineMessageSendingQuotaFragment } from './LineMessageSendingQuota.generated'

const props = defineProps<{
  fragment: LineMessageSendingQuotaFragment
}>()

type UsageRatio =
  | {
      type: 'unlimited'
    }
  | {
      type: 'limited'
      ratio: number
    }

const usageRatio = computed<UsageRatio | undefined>(() => {
  const { quota, totalUsage } = props.fragment.lineMessagingCurrentMonthQuota

  if (quota.__typename === 'LineMessagingCurrentMonthQuota_None') {
    return { type: 'unlimited' }
  }

  if (quota.__typename === 'LineMessagingCurrentMonthQuota_Limited') {
    const rawRatio = (totalUsage / quota.limit) * 100

    return {
      type: 'limited',
      ratio: Math.round(rawRatio),
    }
  }

  throw new Error('Invalid quota type')
})
</script>

<template>
  <section>
    <p>
      <span>配信済みのメッセージ数： </span>
      <span :style="{ fontSize: '18px' }">{{
        fragment.lineMessagingCurrentMonthQuota.totalUsage
      }}</span>
      <span> / </span>
      <span
        v-if="
          fragment.lineMessagingCurrentMonthQuota.quota.__typename ===
          'LineMessagingCurrentMonthQuota_Limited'
        "
        >{{ fragment.lineMessagingCurrentMonthQuota.quota.limit }}</span
      >
      <span v-else>無制限</span>
    </p>
    <div :class="$style.progress" v-if="usageRatio?.type === 'limited'">
      <div
        :class="$style.progressContent"
        :style="{ width: usageRatio.ratio + '%' }"
      >
        {{ usageRatio.ratio }}%
      </div>
    </div>
    <p :class="$style.annotation">
      ※配信済みのメッセージ数について、通常は毎日午前中に更新されます。
    </p>
  </section>
</template>

<style module lang="scss">
.value {
  display: flex;
}

.title {
  font-size: 16px;
  font-weight: bold;
}

.annotation {
  color: $color-text-and-object-low-emphasis;
  font-size: 12px;
  margin-top: 8px;
}

.progress {
  width: 100%;
  background-color: $color-background-base;
  height: 24px;
  border-radius: 6px;
  overflow: hidden;
  margin-top: 8px;
}

.progressContent {
  height: 100%;
  background: repeating-linear-gradient(
    -45deg,
    $color-text-and-object-accent-primary,
    $color-text-and-object-accent-primary 8px,
    rgba($color-text-and-object-accent-primary, 0.9) 8px,
    rgba($color-text-and-object-accent-primary, 0.9) 16px
  );
  color: #ffffff;
  padding: 4px 8px;
  line-height: 16px;
}
</style>
